import React from 'react'

import { FilterHandler } from '@btime/react-contexts'
import UserStocksLoader from './_load/UserStocksLoader'
import UserStocksTable from './table/UserStocksTable'
import Scroll from '../../../../components/helpers/Scroll'

const UserStocks = () => {
  return (
    <Scroll overflowX={'hidden'} overflowY={'auto'} maxHeight="35rem" width="45rem" height="100%">
      <FilterHandler>
        <UserStocksLoader>
          <UserStocksTable />
        </UserStocksLoader>
      </FilterHandler>
    </Scroll>
  )
}

export default UserStocks
